import React, { useState, useEffect } from "react";
import { InputComponent } from "./styles";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  transparent?: boolean;
}

export function Input({
  type = "text",
  transparent = false,
  placeholder,
  className = "",
  onChange,
  onKeyDown,
  onKeyUp,
  defaultValue,
  value,
  autoComplete,
  readOnly,
  maxLength,
  id = "",
  ...props
}: InputProps) {
  const [internalValue, setInternalValue] = useState(value || "");

  useEffect(() => {
    setInternalValue(value || "");
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setInternalValue(newValue);
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <InputComponent
      id={id}
      type={type}
      transparent={transparent}
      placeholder={placeholder}
      className={className}
      onChange={handleChange}
      onKeyDown={onKeyDown}
      onKeyUp={onKeyUp}
      autoComplete={autoComplete}
      readOnly={readOnly}
      maxLength={maxLength}
      value={internalValue}
      {...props}
    />
  );
}
